import { globalOnChange } from "../../../src/models/BaseObject";
import C1_EloItem from "../model/C1_EloItem";

/** Recompute the shared floor layout for facet edits, including manual moves and undo.
 * Multiple item changes during one drag frame need only one layout pass.
 */
export function watchEloDisplayUpdates(refresh: () => void): () => void {
  let frame: number | undefined;
  const subscription = globalOnChange.subscribe((object, property) => {
    if (!(object.c1 instanceof C1_EloItem)) return;
    if (typeof property === "string" && property !== "c1" && !property.startsWith("c1.")) return;
    if (frame !== undefined) return;
    frame = requestAnimationFrame(() => {
      frame = undefined;
      refresh();
    });
  });
  return () => {
    globalOnChange.unsubscribe(subscription);
    if (frame !== undefined) cancelAnimationFrame(frame);
  };
}
